export enum UserRole {
  LOCATING_OPERATOR = 'locatingOperator',
  PORTAL_ADMINISTRATOR = 'portalAdministrator',
  UNIT_ADMINISTRATOR = 'unitAdministrator',
  SECURITY_MANAGER = 'securityManager',
  NURSE = 'nurse',
  CHARGE_NURSE = 'chargeNurse',
  DOCTOR = 'doctor',
  HEALTH_CARE_ASSISTANT = 'healthcareAssistant',
  CARDIOLOGIST = 'cardiologist',
  SECURITY_STAFF = 'securityStaff',
  CLEANING_STAFF = 'cleaningStaff',
  PORTERING = 'portering',
  SECURITY_COMMAND_CENTRE = 'securityCommandCentre',
}
